import { createElement, Fragment, memo, useState } from 'react';

import { useAtom } from 'jotai';
import { Languages } from 'lucide-react';
import { mutate } from 'swr';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { localeToUIMap } from './constants';

import css from './LocaleSelect.module.css';

import { localeAtom } from 'v2/atoms/localeAtom';
import { Locale } from 'v2/constants';
import { Nullable } from 'v2/types';

export const LocaleSelect = memo(() => {
  const [locale, setLocale] = useAtom(localeAtom);

  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);

  const handleLocaleChange = (locale: Locale) => () => {
    setLocale(locale);
    handleClose();
    mutate(() => true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Button
        className={css.localeSelectButton}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={<Languages width={20} />}
        disabled
      >
        {locale}
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {Object.values(Locale).map((l) => (
          <MenuItem key={l} className={css.localeSelectMenuItem} onClick={handleLocaleChange(l)}>
            {createElement(localeToUIMap[l].icon)} {l}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
});

LocaleSelect.displayName = 'LocaleSelect';
